import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal, Stack, Button } from "@mui/material";

import { InputTitle, PageTitle } from "../../../../components/Typography";
import { classes } from "../../../../utils/class";
import { CheckBoxes } from "../../../../components/CustomInput";

const ChangeStatusArchive = ({
  open = false,
  handleClose = function () {},
  handleContinue = function () {},
}) => {
  const [change, setChange] = useState([]);
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
      >
        <Box
          sx={{
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(-50%,-50%)",
            backgroundColor: "text.contrast",
            maxWidth: "400px",
          }}
        >
          <Stack position={"relative"}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 10,
                top: 10,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack gap={2} padding={5}>
            <PageTitle>Change Status</PageTitle>
            <InputTitle>
              Are you sure you want to unarchive this warehouse?
            </InputTitle>
            <CheckBoxes
              options={["I want to change the status"]}
              selectedOptions={change}
              onChange={(option, checked) => {
                if (checked) {
                  setChange([option]);
                } else {
                  setChange(null);
                }
              }}
              sx={{ fontSize: "12px" }}
            />
            <Stack direction={"row"} gap={1} justifyContent={"space-between"}>
              <Button sx={classes.buttonCancel} fullWidth onClick={handleClose}>
                Cancel
              </Button>
              <Button
                disabled={change === null}
                fullWidth
                sx={classes.buttonSave}
                onClick={() => {
                  handleContinue();
                }}
              >
                Continue
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};
export default ChangeStatusArchive;
